import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'


function checkSeatsAndSteeringWheelBadges_q6etron_s_line() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}


function addListeners_q6etron_s_line(frontCheckboxesMap, modalsCheckboxesMap) {


	//console.log("reload? 0")
	// Remove YFB layer onLoad if package and YN1 OR YN2 active
	function checkYFB() {
		document.getElementById("YFB_Q6etron-img").hidden = true;
		//console.log("reload? 1")
	}
	function checkYFB_YN1() {
		document.getElementById("YFB_Q6etron-img").hidden = true;
		//console.log("reload? 2")
	}
	
	if ((frontCheckboxesMap['YFB_Q6etron'].checked == true) && (frontCheckboxesMap['YN1'].checked == true)) { 
		setTimeout(checkYFB_YN1, 100);
	}
	if ((frontCheckboxesMap['YFB_Q6etron'].checked == true) && (frontCheckboxesMap['YN2'].checked == true)) { 
		setTimeout(checkYFB, 100);
	}
	

    frontCheckboxesMap['FC1'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FC1', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1'].checked == false) { 
				frontCheckboxesMap['YN1'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2'].checked == false) { 
				frontCheckboxesMap['YN2'].disabled = true
			}
			
			if (frontCheckboxesMap['YFB_Q6etron'].checked == false) { 
				frontCheckboxesMap['YFB_Q6etron'].disabled = true
			}
			
		} else {
			checkLocks_q6etron_s_line(frontCheckboxesMap)
		}
		getPackageImages_q6etron_s_line('FC1', frontCheckboxesMap)
	})

    frontCheckboxesMap['Q8H'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('Q8H', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1'].checked == false) { 
				frontCheckboxesMap['YN1'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2'].checked == false) { 
				frontCheckboxesMap['YN2'].disabled = true
			}
			
			if (frontCheckboxesMap['YFB_Q6etron'].checked == false) { 
				frontCheckboxesMap['YFB_Q6etron'].disabled = true
			}
			
		} else {
			checkLocks_q6etron_s_line(frontCheckboxesMap)
		}
		getPackageImages_q6etron_s_line('Q8H', frontCheckboxesMap)
	})

	frontCheckboxesMap['0UD'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0UD', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1'].checked == false) { 
				frontCheckboxesMap['YN1'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2'].checked == false) { 
				frontCheckboxesMap['YN2'].disabled = true
			}
			
			if (frontCheckboxesMap['YFB_Q6etron'].checked == false) { 
				frontCheckboxesMap['YFB_Q6etron'].disabled = true
			}
			
		} else {
			checkLocks_q6etron_s_line(frontCheckboxesMap)
		}
		getPackageImages_q6etron_s_line('0UD', frontCheckboxesMap)
	})

    
	frontCheckboxesMap['FZ9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FZ9',this.checked)
		if (this.checked) {
			//If we dont come from the modal
			/*
			if (frontCheckboxesMap['YN1'].checked == false) { 
				frontCheckboxesMap['YN1'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2'].checked == false) { 
				frontCheckboxesMap['YN2'].disabled = true
			}
				*/
		} else {
			checkLocks_q6etron_s_line(frontCheckboxesMap)
		}
		getPackageImages_q6etron_s_line('FZ9', frontCheckboxesMap)
	})

    frontCheckboxesMap['0TF'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0TF', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1'].checked == false) { 
				frontCheckboxesMap['YN1'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2'].checked == false) { 
				frontCheckboxesMap['YN2'].disabled = true
			}
			
			if (frontCheckboxesMap['YFB_Q6etron'].checked == false) { 
				frontCheckboxesMap['YFB_Q6etron'].disabled = true
			}
			
		} else {
			checkLocks_q6etron_s_line(frontCheckboxesMap)
		}
		getPackageImages_q6etron_s_line('0TF', frontCheckboxesMap)
	})


	frontCheckboxesMap['YN1'].addEventListener('change', function () {
		
		//Basisbild austauschen
		if (frontCheckboxesMap['YN1'].checked == true) {		
			//document.getElementById("front_background_image").src="img/06_paketauswahl/q7q8/paketauswahl/au53x_sport-plus_wabe_q4q_yve_frt_basis.png";
		} else {
			//document.getElementById("front_background_image").src="img/06_paketauswahl/q7q8/paketauswahl/au53x_paketauswahl_rsq8-iks.png";
		}
		//Basisbild austauschen

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YN1', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2'].checked == false) { 
				frontCheckboxesMap['YN2'].disabled = true
			}
			if (frontCheckboxesMap['FC1'].checked == false) { 
				frontCheckboxesMap['FC1'].disabled = true
			}
			if (frontCheckboxesMap['Q8H'].checked == false) { 
				frontCheckboxesMap['Q8H'].disabled = true
			}
			if (frontCheckboxesMap['0UD'].checked == false) { 
				frontCheckboxesMap['0UD'].disabled = true
			}
			if (frontCheckboxesMap['0TF'].checked == false) { 
				frontCheckboxesMap['0TF'].disabled = true
			}
			
			if (frontCheckboxesMap['YFA_Q6etron'].checked == false) { 
				frontCheckboxesMap['YFA_Q6etron'].disabled = true
			}
			// Remove YFB layer if package active
			if (frontCheckboxesMap['YFB_Q6etron'].checked == true) { 
				document.getElementById("YFB_Q6etron-img").hidden = true;
			}
			/*
			if (frontCheckboxesMap['FZ9'].checked == false) { 
				frontCheckboxesMap['FZ9'].disabled = true
			}*/
			
			
		} else {
			checkLocks_q6etron_s_line(frontCheckboxesMap)

			// Add YFB layer if package active
			if (frontCheckboxesMap['YFB_Q6etron'].checked == true) { 
				document.getElementById("YFB_Q6etron-img").hidden = false;
			}

			// prevent "next" button when YFB selected
			if ((frontCheckboxesMap['YFB_Q6etron'].checked == true)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}

		}
		getPackageImages_q6etron_s_line('YN1', frontCheckboxesMap)
	})	

	frontCheckboxesMap['YN2'].addEventListener('change', function () {
		
		//Basisbild austauschen
		if (frontCheckboxesMap['YN1'].checked == true) {		
			//document.getElementById("front_background_image").src="img/06_paketauswahl/q7q8/paketauswahl/au53x_sport-plus_wabe_q4q_yve_frt_basis.png";
		} else {
			//document.getElementById("front_background_image").src="img/06_paketauswahl/q7q8/paketauswahl/au53x_paketauswahl_rsq8-iks.png";
		}
		//Basisbild austauschen

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YN2', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1'].checked == false) { 
				frontCheckboxesMap['YN1'].disabled = true
			}
			if (frontCheckboxesMap['FC1'].checked == false) { 
				frontCheckboxesMap['FC1'].disabled = true
			}
			if (frontCheckboxesMap['Q8H'].checked == false) { 
				frontCheckboxesMap['Q8H'].disabled = true
			}
			if (frontCheckboxesMap['0UD'].checked == false) { 
				frontCheckboxesMap['0UD'].disabled = true
			}
			if (frontCheckboxesMap['0TF'].checked == false) { 
				frontCheckboxesMap['0TF'].disabled = true
			}
			
			if (frontCheckboxesMap['YFA_Q6etron'].checked == false) { 
				frontCheckboxesMap['YFA_Q6etron'].disabled = true
			}

			// Remove YFB layer if package active
			if (frontCheckboxesMap['YFB_Q6etron'].checked == true) { 
				document.getElementById("YFB_Q6etron-img").hidden = true;
			}
			
			/*if (frontCheckboxesMap['FZ9'].checked == false) { 
				frontCheckboxesMap['FZ9'].disabled = true
			}*/

		} else {
			checkLocks_q6etron_s_line(frontCheckboxesMap)

			
			// Add YFB layer if package active
			if (frontCheckboxesMap['YFB_Q6etron'].checked == true) { 
				document.getElementById("YFB_Q6etron-img").hidden = false;
			}

			// prevent "next" button when YFB selected
			if ((frontCheckboxesMap['YFB_Q6etron'].checked == true)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}
			
		}
		getPackageImages_q6etron_s_line('YN2', frontCheckboxesMap)
	})	

	
	frontCheckboxesMap['YFA_Q6etron'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap);
		saveStateWithAjax('YFA_Q6etron', this.checked);

		const packageIds = ["FC1", "Q8H", "0UD", "0TF"];
		
		if (this.checked) {
			
			// Aktiviere alle Pakete die nicht gecheckt sind
			packageIds.forEach(function(id) {
				if (!frontCheckboxesMap[id].checked) {
					frontCheckboxesMap[id].checked = true;
					frontCheckboxesMap[id].parentElement.classList.add('is-checked');
					saveStateWithAjax(id, true);
					getPackageImages_q6etron_s_line(id, frontCheckboxesMap);
				}
				// Deaktiviere Interaktion
				frontCheckboxesMap[id].disabled = true;
			});

			// Zusätzliche Pakete deaktivieren
			if (!frontCheckboxesMap['YFB_Q6etron'].checked) frontCheckboxesMap['YFB_Q6etron'].disabled = true;
			if (!frontCheckboxesMap['YN1'].checked) frontCheckboxesMap['YN1'].disabled = true;
			if (!frontCheckboxesMap['YN2'].checked) frontCheckboxesMap['YN2'].disabled = true;

		} else {
			
			// Deaktiviere alle Pakete
			packageIds.forEach(function(id) {
				if (frontCheckboxesMap[id].checked) {
					frontCheckboxesMap[id].checked = false;
					frontCheckboxesMap[id].parentElement.classList.remove('is-checked');
					saveStateWithAjax(id, false);
					getPackageImages_q6etron_s_line(id, frontCheckboxesMap);
				}
				// Aktiviere Interaktion wieder
				frontCheckboxesMap[id].disabled = false;
			});

			// Reaktiviere andere Pakete
			frontCheckboxesMap['YN1'].disabled = false;
			frontCheckboxesMap['YN2'].disabled = false;
			
			// Überprüfe Locks neu
			checkLocks_q6etron_s_line(frontCheckboxesMap);
		}

		getPackageImages_q6etron_s_line('YFA_Q6etron', frontCheckboxesMap);
	});

	frontCheckboxesMap['YFB_Q6etron'].addEventListener('change', function () {
		
		//Basisbild austauschen
		updateBackgroundImage();

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YFB_Q6etron', this.checked);

		if (this.checked) {

			//If we dont come from the modal
			if (frontCheckboxesMap['FC1'].checked == false) { 
				frontCheckboxesMap['FC1'].disabled = true
			}
			if (frontCheckboxesMap['YFA_Q6etron'].checked == false) { 
				frontCheckboxesMap['YFA_Q6etron'].disabled = true
			}
			if (frontCheckboxesMap['Q8H'].checked == false) { 
				frontCheckboxesMap['Q8H'].disabled = true
			}
			if (frontCheckboxesMap['0UD'].checked == false) { 
				frontCheckboxesMap['0UD'].disabled = true
			}
			if (frontCheckboxesMap['0TF'].checked == false) { 
				frontCheckboxesMap['0TF'].disabled = true
			}

			// prevent "next" button without selecting YN1 OR YN2
			if ((frontCheckboxesMap['YN1'].checked == false) && (frontCheckboxesMap['YN2'].checked == false)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}

			// Remove YN1/YN2 layers if packages active
			if ((frontCheckboxesMap['YN1'].checked == true)) { 
				//document.getElementById("YN1_A6_C9-img").hidden = true;
			}
			if ((frontCheckboxesMap['YN2'].checked == true)) { 
				document.getElementById("YN2-img").hidden = true;
			}

		} else {
			checkLocks_q6etron_s_line(frontCheckboxesMap)

			// Add YN1/YN2 layers if packages active
			if ((frontCheckboxesMap['YN1'].checked == true)) { 
				document.getElementById("YN1-img").hidden = false;
			}
			if ((frontCheckboxesMap['YN2'].checked == true)) { 
				document.getElementById("YN2-img").hidden = false;
			}
		}
		if ((frontCheckboxesMap['YN1'].checked == false)) getPackageImages_q6etron_s_line('YFB_Q6etron', frontCheckboxesMap)
	})	

}

/**Controls frontcheckboxes disable */
function checkLocks_q6etron_s_line(frontCheckboxesMap) {
    //DEFINE UNLOCK CONDITIONS	
    const unlockConditionForFC1 = !frontCheckboxesMap['YN1'].checked && !frontCheckboxesMap['YN2'].checked && !frontCheckboxesMap['YFA_Q6etron'].checked && !frontCheckboxesMap['YFB_Q6etron'].checked
    const unlockConditionForYN1 = !frontCheckboxesMap['FC1'].checked && !frontCheckboxesMap['YN2'].checked && !frontCheckboxesMap['Q8H'].checked && !frontCheckboxesMap['0UD'].checked && !frontCheckboxesMap['0TF'].checked && !frontCheckboxesMap['YFA_Q6etron'].checked
    const unlockConditionForYN2 = !frontCheckboxesMap['FC1'].checked && !frontCheckboxesMap['YN1'].checked && !frontCheckboxesMap['Q8H'].checked && !frontCheckboxesMap['0UD'].checked && !frontCheckboxesMap['0TF'].checked && !frontCheckboxesMap['YFA_Q6etron'].checked
    const unlockConditionForQ8H_7HH = !frontCheckboxesMap['YN1'].checked && !frontCheckboxesMap['YN2'].checked && !frontCheckboxesMap['YFA_Q6etron'].checked && !frontCheckboxesMap['YFB_Q6etron'].checked
	const unlockConditionFor0UD = !frontCheckboxesMap['YN1'].checked && !frontCheckboxesMap['YN2'].checked && !frontCheckboxesMap['YFA_Q6etron'].checked && !frontCheckboxesMap['YFB_Q6etron'].checked
	const unlockConditionForFZ9 = true
	const unlockConditionFor0TF = !frontCheckboxesMap['YN1'].checked && !frontCheckboxesMap['YN2'].checked && !frontCheckboxesMap['YFA_Q6etron'].checked && !frontCheckboxesMap['YFB_Q6etron'].checked

	const unlockConditionForYFA = !frontCheckboxesMap['YN1'].checked && !frontCheckboxesMap['YN2'].checked && !frontCheckboxesMap['YFB_Q6etron'].checked
	const unlockConditionForYFB = !frontCheckboxesMap['YFA_Q6etron'].checked && !frontCheckboxesMap['0TF'].checked

	frontCheckboxesMap['Q8H'].disabled = !unlockConditionForQ8H_7HH
	frontCheckboxesMap['0UD'].disabled = !unlockConditionFor0UD
	frontCheckboxesMap['FZ9'].disabled = !unlockConditionForFZ9
	frontCheckboxesMap['0TF'].disabled = !unlockConditionFor0TF

    frontCheckboxesMap['YN1'].disabled = !unlockConditionForYN1
    frontCheckboxesMap['YN2'].disabled = !unlockConditionForYN2
    frontCheckboxesMap['FC1'].disabled = !unlockConditionForFC1

    frontCheckboxesMap['YFA_Q6etron'].disabled = !unlockConditionForYFA
    frontCheckboxesMap['YFB_Q6etron'].disabled = !unlockConditionForYFB
}


/**Gets images for all packages depending on selected packages */

function getImages_q6etron_s_line(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		getPackageImages_q6etron_s_line(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_q6etron_s_line(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')


    if (checkboxesMap['YFA_Q6etron'] && checkboxesMap['YFA_Q6etron'].checked) {
		setTimeout(function() {
			let imgIds = ["FC1-img", "Q8H-img", "0UD-img", "0TF-img"];
			imgIds.forEach(function(id) {
				let img = document.getElementById(id);
				if (img) img.setAttribute("hidden", "");
			});
		}, 1);
	}


	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
}


function updateBackgroundImage() {
	const isYN1_Q6etron_Checked = isCheckboxCheckedByAuiCode('YN1');
	const isYN2_Q6etron_Checked = isCheckboxCheckedByAuiCode('YN2');
	//Basisbild austauschen
    if (isYN1_Q6etron_Checked) {		
		//document.getElementById("front_background_image").src="img/06_paketauswahl/a6/au592_a6_paketauswahl_sline_s_yn1/au592_a6_sline_s_yn1_paketauswahl.png";
	} else if (isYN2_Q6etron_Checked) {
		//document.getElementById("front_background_image").src="img/06_paketauswahl/a6/au592_a6_paketauswahl_sline_s_yn2/au592_a6_sline_s_yn1_paketauswahl.png";
	} else {
		//document.getElementById("front_background_image").src="img/06_paketauswahl/a6/au592_a6_paketauswahl_sline_s/au592_a6_sline_s_paketauswahl.png";
	}
}

function isCheckboxCheckedByAuiCode(auiCode) {
    const label = document.querySelector(`label[data-auicode="${auiCode}"]`);
    if (label) {
        const checkbox = label.querySelector('input[type="checkbox"]');
        return checkbox ? checkbox.checked : false;
    }
    return false;
}

document.addEventListener('DOMContentLoaded', function () {
	const isYN1_Q6etron_Checked = isCheckboxCheckedByAuiCode('YN1');
	if(isYN1_Q6etron_Checked) {
		updateBackgroundImage();
	}
	const isYN2_Q6etron_Checked = isCheckboxCheckedByAuiCode('YN2');
	if(isYN2_Q6etron_Checked) {
		updateBackgroundImage();
	}
	
});


export { addListeners_q6etron_s_line, saveStateWithAjax, checkLocks_q6etron_s_line, getImages_q6etron_s_line, getPackageImages_q6etron_s_line, checkSeatsAndSteeringWheelBadges_q6etron_s_line}

